module.exports = __webpack_public_path__ + "img/5.f64a787b.jpg";